import { keyframes, styled, BoxProps as IBoxProps  } from '@mui/material';

const translateTopDown = keyframes`
  0%   { transform: translate3d(0px, 0px, 0px) rotateZ(0deg); }
  50%  { transform: translate3d(0px, 6px, 0px) rotateZ(0deg); }
  100% { transform: translate3d(0px, 6px, 0px) rotateZ(45deg); }
`;

const translateTopUp = keyframes`
  0%   { transform: translate3d(0px, 6px, 0px) rotateZ(45deg); }
  50%  { transform: translate3d(0px, 6px, 0px) rotateZ(0deg); }
  100% { transform: translate3d(0px, 0px, 0px) rotateZ(0deg); }
`;

const translateBottomDown = keyframes`
  0%   { transform: translate3d(0px, 0px, 0px) rotateZ(0deg); }
  50%  { transform: translate3d(0px, -6px, 0px) rotateZ(0deg); }
  100% { transform: translate3d(0px, -6px, 0px) rotateZ(-45deg); }
`;

const translateBottomUp = keyframes`
  0%   { transform: translate3d(0px, -6px, 0px) rotateZ(-45deg); }
  50%  { transform: translate3d(0px, -6px, 0px) rotateZ(0deg); }
  100% { transform: translate3d(0px, 0px, 0px) rotateZ(0deg); }
`;

export const MenuIconWrapper = styled("div")<Partial<IBoxProps>>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '18px',
  height: '14px',
  marginRight: '-1px',
  cursor: 'pointer',
  position: 'relative',
  transform: 'rotate(0deg)',
  transition: '0.3s ease-in-out',
  '@media (min-width: 375px) and (max-width: 425px)': {
    marginRight: '-1px',
  },
  '@media (min-width: 320px) and (max-width: 375px)': {
    marginRight: '0px',
  },
  '@media (min-width: 0px) and (max-width: 320px)': {
    marginRight: '0px',
  },
  '.menu-icon-top, .menu-icon-middle, .menu-icon-bottom': {
    display: 'block',
    position: 'absolute',
    height: '2px',
    width: '1.12rem',
    backgroundColor: '#fff',
    opacity: 1,
    left: 0,
    transition: '0.3s ease-in-out',
    [theme.breakpoints.down('sm')]: {
      width: '1.2rem',
    },
  },
  '.menu-icon-top': {
    top: 0,
  },
  '.menu-icon-middle': {
    top: '6px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '.menu-icon-middle-inner': {
    width: '1.12rem',
    height: '2px',
    backgroundColor: '#fff',
    transition: '0.3s ease-in-out',
  },
  '.menu-icon-bottom': {
    top: '12px',
  },
  '&.transform-to-lines': {
    '.menu-icon-top': {
      animation: `${translateTopUp} 0.4s ease-in-out forwards`,
    },
    '.menu-icon-middle': {
      opacity: 1,
    },
    '.menu-icon-bottom': {
      animation: `${translateBottomUp} 0.4s ease-in-out forwards`,
    },
  },
  '&.transform-to-cross': {
    '.menu-icon-top': {
      animation: `${translateTopDown} 0.4s ease-in-out forwards`,
    },
    '.menu-icon-middle': {
      opacity: 0,
    },
    '.menu-icon-bottom': {
      animation: `${translateBottomDown} 0.4s ease-in-out forwards`,
    },
  },
}));